var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.433 0.234817C10.7451 0.547515 10.7447 1.05405 10.432 1.3662L4.3839 7.4036C4.07139 7.71555 3.56524 7.71532 3.25302 7.4031L0.234317 4.3844C-0.0781057 4.07198 -0.0781057 3.56544 0.234317 3.25302C0.54674 2.94059 1.05328 2.94059 1.3657 3.25302L3.81921 5.70652L9.30158 0.233818C9.61427 -0.0783289 10.1208 -0.0778818 10.433 0.234817ZM15.7662 0.234817C16.0783 0.547515 16.0779 1.05405 15.7652 1.3662L9.71712 7.4036C9.4046 7.71557 8.8984 7.71532 8.58618 7.40304L7.70101 6.5177C7.38862 6.20525 7.38866 5.69871 7.70112 5.38632C8.01357 5.07393 8.5201 5.07397 8.8325 5.38642L9.15248 5.70647L14.6348 0.233818C14.9475 -0.0783289 15.454 -0.0778818 15.7662 0.234817Z",
    fill: "#23A484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMessage);
export default __webpack_public_path__ + "static/media/checkMessage.d3426d10dd5e4725836996c6fe141efb.svg";
export { ForwardRef as ReactComponent };